<div class="image-modal-container">
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <ng-container *ngIf="data.images">
    <button
      *ngIf="data.images.length > 1"
      class="carousel-control-prev"
      type="button"
      (click)="prevImg()"
    >
      <span
        class="carousel-control-prev-icon"
        aria-hidden="true"
        style="filter: invert(1)"
      ></span>
    </button>

    <img [src]="data.images[currentIndex]" class="image-full" />

    <button
      *ngIf="data.images.length > 1"
      class="carousel-control-next"
      type="button"
      (click)="nextImg()"
    >
      <span
        class="carousel-control-next-icon"
        aria-hidden="true"
        style="filter: invert(1)"
      ></span>
    </button>

    <div *ngIf="data.images.length > 1" class="image-counter">
      {{ currentIndex + 1 }} / {{ data.images.length }}
    </div>
  </ng-container>
</div>
